// frontend/src/services/api.js
// Serviço central de comunicação com o backend via Axios

import axios from "axios";


const ONBOARDING_MUTATION_PATTERNS = [
  /\/patients(?:\/|$)/,
  /\/appointments(?:\/|$)/,
  /\/anamnese(?:\/|$)/,
  /\/clinic-settings(?:\/|$)/,
  /\/prescriptions\/documents(?:\/|$)/,
  /\/contextual-ai(?:\/|$)/,
  /\/ai-nlp\/anamnese\/analyze(?:\/|$)/,
  /\/billing\/(?:invoices|external-revenues|expenses)(?:\/|$)/,
];


export const isOnboardingRelevantMutation = (method, url) =>
  ['post', 'put', 'patch'].includes(String(method || '').toLowerCase()) &&
  ONBOARDING_MUTATION_PATTERNS.some((pattern) => pattern.test(String(url || '')));

/**
 * Estratégia:
 * - Se REACT_APP_BACKEND_URL estiver definida, usamos ela + /api
 *   (ex: REACT_APP_BACKEND_URL=https://odontoassistai.com.br).
 * - Caso contrário, usamos baseURL relativa "/api",
 *   assumindo que o Nginx faz proxy de /api para o backend.
 */

let baseURL = "/api";

if (process.env.REACT_APP_BACKEND_URL) {
  const raw = process.env.REACT_APP_BACKEND_URL.trim();
  if (raw.endsWith("/")) {
    baseURL = `${raw}api`;
  } else {
    baseURL = `${raw}/api`;
  }
}

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para incluir token JWT automaticamente (se existir)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Após mutações que podem concluir uma conquista, solicita atualização da
// camada de onboarding. O evento só é emitido quando a resposta foi bem-sucedida.
api.interceptors.response.use((response) => {
  const method = String(response.config?.method || '').toLowerCase();
  const url = String(response.config?.url || '');

  if (isOnboardingRelevantMutation(method, url) && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('odontoassist:onboarding-refresh'));
  }
  return response;
});

export default api;
